@if (attachForm) {
  <div [formGroup]="attachForm">
    <div class="flex flex-column gap-1">
      @if (renderStartvalutaFeld || renderStartvalutaCalendar || renderStartvalutaDropDown) {
        <div class="flex flex-row align-items-center w-28rem"><label class="w-13rem"
                                                                     for="startValutaId">{{ "investment.label.startvaluta" | translate }}</label>
          <p-input-group>
            @if (renderStartvalutaFeld) {
              <p-date-picker [tabindex]="5" [style]="{width: '100%'}" formControlName="startValuta" id="startValutaId"
                             dateFormat="dd.mm.yy" appendTo="body"
                             appDateInput/>
            }
            @if (renderStartvalutaCalendar) {
              <p-date-picker no-border-right [tabindex]="5" [style]="{width: '100%'}" [minDate]="minDate"
                             formControlName="startValuta" appendTo="body"
                             [showIcon]="true"
                             dateFormat="dd.mm.yy" appDateInput/>
            }
            @if (renderStartvalutaDropDown) {
              <p-select formControlName="startValuta" [options]="availableValutaeForSelect" optionLabel="label"
                        appendTo="body" optionValue="value"/>
            }
          </p-input-group>
        </div>
      }
      @if (renderFaelligkeitFeld || renderFaelligkeitCalendar) {
        <div class="flex flex-row align-items-center w-28rem">
          <label class="w-13rem" for="renderFaelligkeitId">{{ "investment.label.faelligkeit" | translate }}</label>
          <p-input-group>
            @if (renderFaelligkeitCalendar) {
              @if (dayDiff === 0) {
                <p-date-picker [tabindex]="6" no-border-right appDateInput [baseDateControlName]="'startValuta'"
                               (isYearMonthInput)="onYearMonthInputMatch($event)"
                               [style]="{width: '100%'}" appendTo="body"
                               formControlName="faelligkeit" showIcon="true"
                               dateFormat="dd.mm.yy"
                               [minDate]="minDate" id="renderFaelligkeitId" inputId="form_faelligkeit_input"
                               (onFocus)="focusFaelligkeit()"/>
              } @else {
                <p-date-picker [tabindex]="6" appDateInput [baseDateControlName]="'startValuta'"
                               (isYearMonthInput)="onYearMonthInputMatch($event)"
                               class="no-radius-right w-12rem" [style]="{width: '100%'}"
                               formControlName="faelligkeit" appendTo="body"
                               [showTime]="false" showIcon="true" dateFormat="dd.mm.yy" [minDate]="minDate"
                               inputId="form_faelligkeit_input"
                               (onFocus)="focusFaelligkeit()"/>
              }
            }
            @if (renderFaelligkeitFeld) {
              @if (dayDiff) {
                <p-date-picker [tabindex]="6" no-border-right class="w-10rem" [style]="{width: '100%'}"
                               id="form_faelligkeit" appendTo="body"
                               formControlName="faelligkeit" dateFormat="dd.mm.yy"/>
              } @else {
                <p-date-picker [tabindex]="6" class="w-19rem" [style]="{width: '100%'}"
                               id="form_faelligkeit" appendTo="body"
                               formControlName="faelligkeit"
                               dateFormat="dd.mm.yy"/>
              }
            }
            @if (renderTage && renderFaelligkeitFeld) {
              @if (dayDiff > 1) {
                <p-inputgroup-addon class="w-9rem">{{ dayDiff }} {{ "investment.label.days" | translate }}
                </p-inputgroup-addon>
              }
              @if (dayDiff === 1) {
                <p-inputgroup-addon class="w-9rem">{{ dayDiff }} {{ "investment.label.day" | translate }}
                </p-inputgroup-addon>
              }
            } @else {
              @if (dayDiff > 1) {
                <p-inputgroup-addon class="w-7rem">{{ dayDiff }} {{ "investment.label.days" | translate }}
                </p-inputgroup-addon>
              }
              @if (dayDiff === 1) {
                <p-inputgroup-addon class="w-7rem">{{ dayDiff }} {{ "investment.label.day" | translate }}
                </p-inputgroup-addon>
              }
            }
          </p-input-group>
        </div>
      }</div>
  </div>
}
